import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import Axios from "axios";
import { Notyf } from "notyf";

import "notyf/notyf.min.css";
import server from "../../../variables";
import { printBillViaBluetooth } from "../../../helperfunction/thermalPrint";

const PrintBillModal = ({ open, handleClose, billID }) => {
  const notyf = new Notyf();
  const navigate = useNavigate();
  const [bill, setBill] = useState({});

  const handlePrint = async () => {
    try {
      await printBillViaBluetooth(bill);
      notyf.success("Bill sent to printer!");
    } catch (err) {
      notyf.error(err.message || "Printing failed!");
    }
  };

  useEffect(() => {
    getBill();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getBill = async () => {
    await Axios.get(server + "user/get-bill/" + billID, {
      headers: { authorization: localStorage.getItem("token") },
    })
      .then(({ data }) => {
        if (data.status === 410) {
          navigate("/");
        } else if (data.status === 200) {
          setBill(data.bill);
        } else {
          notyf.error({
            position: {
              x: "right",
              y: "top",
            },
            message: data.message,
            duration: 3000,
            dismissible: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        notyf.error({
          position: {
            x: "right",
            y: "top",
          },
          message: "Internal Server Error!",
          duration: 3000,
          dismissible: true,
        });
      });
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Print Bill</DialogTitle>

        <div
          style={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <button className="btn btn-outline-primary" onClick={handlePrint}>
            <i className="bi bi-printer-fill"></i>
          </button>
        </div>
        <DialogContent>
          <div
            className="container-fluid payslip"
            style={{
              fontSize: "0.75rem",
              paddingRight: "6px", // ✅ ONLY CHANGE
            }}
          >
            {/* COMPANY TITLE */}
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <h6 style={{ margin: 0, fontWeight: "bold" }}>
                Govt. of Madhya Pradesh
              </h6>
              <h6 style={{ margin: 0, fontWeight: "bold" }}>
                Nagar Parishad {bill.otherDetails?.schemeName}
              </h6>
              <h6 style={{ margin: 0, fontWeight: "bold" }}>
                {bill.schemedistrict} District (M.P.)
              </h6>
            </div>

            {/* CUSTOMER DETAILS */}
            <div style={{ marginBottom: "14px" }}>
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: "2px solid #333",
                  paddingBottom: "6px",
                  marginBottom: "8px",
                }}
              >
                Customer Details
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Customer Name</span>
                <span>{bill.otherDetails?.consumerName || "NA"}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Mobile Number</span>
                <span>{bill.otherDetails?.mobileNumber || "NA"}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Customer Id</span>
                <span>{bill?.consumerID || "NA"}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Ward No</span>
                <span>{bill?.wardNumber || "NA"}</span>
              </div>
            </div>

            {/* BILL DETAILS */}
            <div style={{ textAlign: "center", margin: "12px 0" }}>
              <strong>Bill Details</strong>
              <hr style={{ marginTop: "6px", border: "1px solid #333" }} />
            </div>

            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Town </span>
                <span>{bill.otherDetails?.schemeName || "NA"}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Bill No</span>
                <span>{bill.billID || "NA"}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Bill Date</span>
                <span>
                  {" "}
                  {bill.billDate
                    ? new Date(bill.billDate).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",

                    })
                    : "NA"}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Bill Month</span>
                <span>{bill.month || "NA"}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Bill Year</span>
                <span>{bill.year || "NA"}</span>
              </div>

              {/* FIXED CHARGES */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 0",
                }}
              >
                <span style={{ fontWeight: "600" }}>Fixed Charges</span>
                <span style={{ paddingRight: "4px" }}>
                  ₹ {bill.fixedCharges || 0}.00
                </span>
              </div>

              {/* TOTAL */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "6px 0",
                  marginTop: "6px",
                  borderTop: "1px dashed #333",
                  fontWeight: "bold",
                }}
              >
                <span>Total Amount</span>
                <span style={{ paddingRight: "4px" }}>
                  ₹ {bill.fixedCharges || 0}.00
                </span>
              </div>
            </div>

            {/* FOOTER */}
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <h6 style={{ margin: 0, fontWeight: "bold" }}>
                Rean WaterTech Pvt. Ltd.
              </h6>
            </div>
          </div>
        </DialogContent>

      </Dialog>
    </>
  );
};

export default PrintBillModal;
